import { useOrders } from "@web-app/api";
import { Order, Route, User } from "@web-app/types";
import { getMetersToMiles } from "@web-app/utils/helpers";

export default function useRouteDetailsTab({
  route,
}: {
  route: {
    details: Route | null;
    orders: Order[];
  } | null;
}) {
  const { data } = useOrders();

  const assigneesMap = data?.assignees || new Map<string, User>();
  const firstOrder = route && route.orders ? route.orders[0] : null;
  const lastOrder =
    route && route.orders ? route.orders[route.orders.length - 1] : null;

  const timezone = firstOrder?.timezone;

  const getStatus = () => {
    if (route?.details?.status === "COMPLETE") {
      return "Completed";
    }
    if (
      route?.details?.status === "INCOMPLETE" &&
      !route?.details?.assigneeId
    ) {
      return "Unassigned";
    }
    if (route?.details?.status === "INCOMPLETE" && route?.details?.assigneeId) {
      return "Assigned";
    } else if (route?.details?.status === "INPROGRESS") {
      return "In Transit";
    } else {
      return "Unassigned";
    }
  };

  const getActualDistance = () => {
    let distance = 0;

    if (!route || !route.orders) return 0;
    for (const order of route.orders) {
      distance += order.driverRouteDistance ?? 0;
    }
    return getMetersToMiles(distance);
  };

  const getRouteAssignee = () => {
    if (!route?.details?.assigneeId) return null;
    return assigneesMap.get(route?.details.assigneeId) ?? null;
  };

  return {
    firstOrder,
    getActualDistance,
    getRouteAssignee,
    getStatus,
    lastOrder,
    timezone,
  };
}
